import {
  IBillingCodeResponse,
  IBillingCodeByNameResponse,
} from "types/BillingCode";

import { api } from ".";

const billingCodeQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getBillingCodes: builder.query<IBillingCodeResponse, void>({
      query: () => "billing_code",
    }),
    getBillingCodeByName: builder.query<IBillingCodeByNameResponse, string>({
      query: (name) => `billing_code/${name}`,
    }),
  }),
});

export const { useGetBillingCodesQuery, useGetBillingCodeByNameQuery } =
  billingCodeQueries;
